import React from 'react';
import { Mail, Instagram } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-zinc-900 py-24">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl md:text-6xl font-bold mb-8 text-center" style={{fontFamily: 'Syne, sans-serif'}} data-testid="contact-title">Contacto</h1>
        <div className="workout-card rounded-3xl p-12 text-center">
          <div className="space-y-8">
            <div>
              <Mail className="w-12 h-12 mx-auto text-pink-600 mb-4" />
              <h3 className="text-xl font-bold mb-2" style={{fontFamily: 'Syne, sans-serif'}}>Email</h3>
              <a href="mailto:bootyandlegsacademy@gmail.com" className="text-pink-600 hover:text-pink-700">
                bootyandlegsacademy@gmail.com
              </a>
            </div>
            <div>
              <Instagram className="w-12 h-12 mx-auto text-pink-600 mb-4" />
              <h3 className="text-xl font-bold mb-2" style={{fontFamily: 'Syne, sans-serif'}}>Instagram</h3>
              <div className="space-y-2">
                <div><a href="https://instagram.com/deisyfit" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">@deisyfit</a></div>
                <div><a href="https://instagram.com/karenmarinob" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">@karenmarinob</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;